import React, { memo, useState, lazy, Suspense } from "react";
import { Keyboard } from "@material-ui/icons";
import style from "./style.module.scss";

const KeyBoardModal = lazy(() => import("components/KeyboardModal"));

const KeyboardComponent = () => {
  const [isOpenKeyboardModal, setIsOpenKeyboardModal] = useState(false);
  return (
    <>
      <Keyboard
        classes={{ root: style.icon }}
        onClick={() => setIsOpenKeyboardModal((prev) => !prev)}
      />
      {isOpenKeyboardModal && (
        <Suspense fallback={<></>}>
          <KeyBoardModal
            open={isOpenKeyboardModal}
            toggle={() => setIsOpenKeyboardModal((prev) => !prev)}
          />
        </Suspense>
      )}
    </>
  );
};

export default memo(KeyboardComponent);
